// extracted by mini-css-extract-plugin
export var companyLogo = "carousel-module--companyLogo--7255e";
export var customFont = "carousel-module--customFont--55d95";